module.exports = __webpack_public_path__ + "ck.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ck.svg
// module id = 746
// module chunks = 0